<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết Sim</h1>
      <div class="float-right d-flex">
        <button
          class="f12 font-medium btn btn-outline-secondary"
          @click="$router.push('/management-sim')"
        >
          Quay lại
        </button>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20">
        <CardDetail title="Thông tin chung" style="box-shadow: none" :fields="allInfoFields">
          <template #supplier="data">
            {{ mapSupplier[data.value] || data.value }}
          </template>
          <template #activeDate="data">
            {{ data.value | formatDate }}
          </template>
          <template #expiredDate="data">
            {{ data.value | formatDate }}
          </template>
          <template #authenStatus="data">
            <b-badge v-if="data.value" :variant="getAuthenStatusVariant(data.value)">
              {{ getAuthenStatusText(data.value) }}
            </b-badge>
          </template>
          <template #status="data">
            <b-badge v-if="data.value" :variant="getStatusVariant(data.value)">
              {{ getStatusText(data.value) }}
            </b-badge>
          </template>
          <template #simStatus="data">
            <b-badge v-if="data.value" :variant="getSimStatusVariant(data.value)">
              {{ getSimStatusText(data.value) }}
            </b-badge>
          </template>
        </CardDetail>
      </div>
      <div class="card-body px-20">
        <h5 class="mb-3">Lịch sử gia hạn sim</h5>
        <div class="table-responsive">
          <b-table
            :fields="historyFields"
            :items="historyData"
            bordered
            hover
            show-empty
            class="history-table"
          >
            <template #empty>
              <div class="text-center text-info my-2">Không có dữ liệu</div>
            </template>

            <template #cell(time)="data">
              {{ data.item.createdDate | formatDate }}
            </template>

            <template #cell(updater)="data">
              <div v-if="data.item.actionBy || data.item.actionByEmail">
                <div>{{ data.item.actionBy }}</div>
                <div class="text-muted small">{{ data.item.actionByEmail }}</div>
              </div>
            </template>

            <template #cell(action)="data">
              {{ data.item.action }}
            </template>

            <template #cell(note)="data">
              <div v-if="data.item.note">{{ data.item.note }}</div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import CardDetail from '@/components/CardDetail.vue'
  import { DeviceService } from '@/services/device.service'
  import Config from '@/thirdParty/config'
  import { showMessError, showMessErrorResponse } from '@/config/utils'

  export default {
    name: 'DetailSim',
    components: {
      CardDetail,
    },

    data() {
      return {
        Config,
        serial: '',
        showLoading: false,
        simDetail: {},
        historyData: [],
        historyFields: [
          { key: 'time', label: 'Thời gian', class: 'text-center', thStyle: { width: '150px' } },
          { key: 'updater', label: 'Người cập nhật', thStyle: { width: '200px' } },
          { key: 'action', label: 'Hành động', thStyle: { width: '250px' } },
          { key: 'note', label: 'Ghi chú' },
        ],
      }
    },
    computed: {
      mapSupplier() {
        return Config.listOptionSupplierSim
      },
      getStatusVariant() {
        return status => {
          const map = Config.statusDevices?.reduce((acc, curr) => {
            acc[curr.id] = curr.variant
            return acc
          }, {})
          return map[status] || 'primary'
        }
      },
      getStatusText() {
        return code => {
          const map = Config.statusDevices?.reduce((acc, curr) => {
            acc[curr.id] = curr.text
            return acc
          }, {})
          return map[code] || code
        }
      },
      getSimStatusVariant() {
        return status => {
          const map = Config.listOptionStatus?.reduce((acc, curr) => {
            acc[curr.id] = curr.variant
            return acc
          }, {})
          return map[status] || 'primary'
        }
      },
      getSimStatusText() {
        return code => {
          const map = Config.listOptionStatus?.reduce((acc, curr) => {
            acc[curr.id] = curr.text
            return acc
          }, {})
          return map[code] || code
        }
      },
      getAuthenStatusVariant() {
        return code => {
          const map = Config.listOptionAuthenStatusFilter?.reduce((acc, curr) => {
            acc[curr.id] = curr.bgColor
            return acc
          }, {})
          return map[code] || 'primary'
        }
      },
      getAuthenStatusText() {
        return code => {
          const map = Config.listOptionAuthenStatusFilter?.reduce((acc, curr) => {
            acc[curr.id] = curr.text
            return acc
          }, {})
          return map[code] || code
        }
      },

      allInfoFields() {
        return [
          {
            label: 'Nhà cung cấp',
            value: this.simDetail?.supplier || '',
            key: 'supplier',
          },
          { label: 'Serial sim', value: this.simDetail?.serial || '' },
          { label: 'Số thuê bao', value: this.simDetail?.number || '' },
          { label: 'Tên', value: this.simDetail?.customerName || '' },
          { label: 'Email/SĐT', value: this.simDetail?.customerEmail || '' },
          { label: 'Mã gói cước', value: this.simDetail?.packageCode || '' },
          { label: 'Dung lượng', value: this.simDetail?.capacity || '' },
          {
            label: 'Ngày kích hoạt',
            value: this.simDetail?.activeDate || '',
            key: 'activeDate',
          },
          {
            label: 'Ngày hết hạn',
            value: this.simDetail?.expiredDate || '',
            key: 'expiredDate',
          },
          { label: 'Thủ kho', value: this.simDetail?.warehouse || '' },
          {
            label: 'Tình trạng sim',
            value: this.simDetail?.simStatus || '',
            key: 'simStatus',
          },
          {
            label: 'Trạng thái sim',
            value: this.simDetail?.status || '',
            key: 'status',
          },
          {
            label: 'Lý do lỗi',
            value: this.simDetail?.reason || 'Có thông tin thì mới hiển trường này',
          },
          { label: 'Đơn vị bán', value: this.simDetail?.source || '' },
          {
            label: 'Đã xác thực thông tin',
            value: this.simDetail?.authenStatus || '',
            key: 'authenStatus',
          },
        ]
      },
    },
    async created() {
      this.serial = this.$route.params.serial
    },
    async mounted() {
      await this.fetchData()
      await this.fetchHistory()
    },
    methods: {
      async fetchData() {
        try {
          this.showLoading = true
          const response = await DeviceService.getDetailSim({ serial: this.serial })
          if (response.code === 1000) {
            this.simDetail = response.data
          } else {
            showMessError(this, response.message, 3000)
          }
        } catch (error) {
          showMessErrorResponse(this, error, 3000)
        } finally {
          this.showLoading = false
        }
      },
      async fetchHistory() {
        try {
          const response = await DeviceService.getHistorySim({ serial: this.serial })
          if (response.code === 1000) {
            this.historyData = response.data || []
          } else {
            showMessError(this, response.message, 3000)
          }
        } catch (error) {
          showMessErrorResponse(this, error, 3000)
        }
      },
    },
  }
</script>

<style scoped>
  .gap-4 {
    gap: 1rem;
  }

  .history-table ::v-deep thead th {
    background-color: #f8f9fa;
    font-weight: 600;
  }

  .history-table ::v-deep td {
    vertical-align: middle;
  }

  .history-table ::v-deep .small {
    font-size: 0.875rem;
  }
</style>
